import get from 'lodash/get';
import { citations } from '@Constants';
import { activeBreadcrumbForDb } from '@Containers/Breadcrumbs/BreadcrumbsSelectors';
import { REDUCER_KEY_PATENT_FAMILY_CLUSTERING } from './constants';

//  Duplicate logic to get either record count or results count is intended as a reminder to refactor:
//   we're using different fields in different places for the number of results:
//   in breadcrumb and history it is "totalResult", in results preview it is "resultsCount",
//   but in BE response it is "resultSize"...
//   Needs to be uniformed everywhere.

/* From database switcher item */
export const recordCountOrTotalResultFromDatabaseItem = (databaseItem) => {
  if (!databaseItem) return undefined;

  const { context, recordCount, totalResult } = databaseItem;
  return context === citations && recordCount ? recordCount : totalResult;
};

/* From relative context item, Immutable */
export const recordCountOrResultSizeFromRelativeContextItem = (relativeContextItem) => {
  if (!relativeContextItem) return undefined;

  const context = relativeContextItem.get('context');
  const recordCount = relativeContextItem.get('recordCount');
  const resultSize = relativeContextItem.get('resultSize');
  return context === citations && recordCount ? recordCount : resultSize;
};

/* From results preview item */
export const recordCountOrResultsCountFromPreviewItem = (previewItem) => {
  if (!previewItem) return undefined;

  const { context, recordCount, resultsCount } = previewItem;
  return context === citations && recordCount ? recordCount : resultsCount;
};

/* From history item - recent and QB */
export const recordCountOrTotalResultFromHistoryItem = (historyItem) => {
  if (!historyItem) return undefined;

  const { context, recordCount, totalResult } = historyItem;
  return context === citations && recordCount ? recordCount : totalResult;
};

/* From history item - saved */
export const recordCountOrResultSizeFromHistoryItem = (historyItem) => {
  if (!historyItem) return undefined;

  const { context, recordCount, resultSize } = historyItem;
  return context === citations && recordCount ? recordCount : resultSize;
};

/* From breadcrumb */
export const recordCountOrTotalResultFromBreadcrumb = (breadcrumb) => {
  if (!breadcrumb) return undefined;

  const context = breadcrumb.get('context');
  const recordCount = breadcrumb.get('recordCount');
  const totalResult = breadcrumb.get('totalResult');
  return context === citations && recordCount ? recordCount : totalResult;
};

export const recordCountOrTotalResult = (state) => {
  const activeBreadcrumb = activeBreadcrumbForDb(state);
  return recordCountOrTotalResultFromBreadcrumb(activeBreadcrumb);
};

/* From document */
export const groupTitle = (state, { document }) => get(document, 'title');

export const groupOffices = (state, { document }) => get(document, 'patentFamilyGroup.offices');

export const groupCount = (state, { document }) => get(document, 'patentFamilyGroup.count');

/* From state */
export const patentFamilyClusteringState = (state) => state.get(REDUCER_KEY_PATENT_FAMILY_CLUSTERING);

export const patentFamilyGroupsMap = (state) => patentFamilyClusteringState(state).patentFamilyGroupsMap;

export const patentFamilyGroupFromMap = (state, { document }) => {
  const { familyId } = document;
  return patentFamilyGroupsMap(state)[familyId];
};

export const patentFamilyMembers = (state, { document }) => {
  const group = patentFamilyGroupFromMap(state, { document });
  return get(group, 'patentFamilyMembers');
};

export const loadedPatentFamilyMembersCount = (state, { document }) => {
  const group = patentFamilyGroupFromMap(state, { document });
  return get(group, 'patentFamilyMembers.length');
};

export const pageNumber = (state, { document }) => {
  const group = patentFamilyGroupFromMap(state, { document });
  return get(group, 'pageNumber');
};

export const isExpanded = (state, { document }) => {
  const group = patentFamilyGroupFromMap(state, { document });
  return get(group, 'isExpanded');
};

export const isLoading = (state, { document }) => {
  const group = patentFamilyGroupFromMap(state, { document });
  return get(group, 'isLoading');
};
